<div class="outlook-item" *ngIf="value">
  <h5>
    {{ value!.period }} outlook - <span>{{ value!.outlook }}</span>
  </h5>
  <div class="content">
    <span class="outlook-body" [innerHtml]="value!.analysis | safeHtml"></span>
  </div>
</div>
